import dispatch from "./dispatch";
import {ON_CART_OPEN} from "../apps/globals";

export default () => {
    dispatch(ON_CART_OPEN);
}
